// colorUtils.js - hjälpfunktioner för färg/kontrast i kalendern

// Väljer läsbar textfärg (mörk eller vit) utifrån bakgrundsfärgens luminans.
// Ljusa pastellbokningar får mörk text (skarpare) och mörka får vit text.
export function textColorForBackground(hex) {
  if (!hex || typeof hex !== 'string') return '#ffffff';
  let c = hex.replace('#', '').trim();
  if (c.length === 3) c = c.split('').map(x => x + x).join('');
  if (c.length !== 6) return '#ffffff';

  const r = parseInt(c.slice(0, 2), 16);
  const g = parseInt(c.slice(2, 4), 16);
  const b = parseInt(c.slice(4, 6), 16);
  if ([r, g, b].some(Number.isNaN)) return '#ffffff';

  // Relativ luminans (0-1). Tröskel vald så ljusa pasteller får mörk text.
  const luminance = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
  return luminance > 0.6 ? '#1f2937' : '#ffffff';
}
